// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__DgzGU","button":"Pagination_button__CJVj1","p":"Pagination_p__83buo"};